import { defineMessages } from "react-intl";

export const messages = defineMessages({
  entitlementCheckFailedFlagTitle: {
    id: "rovo-extension.hook.entitlement-check-failed-flag-title",
    defaultMessage: "Failed to retrieve Rovo access",
    description: "Title for the entitlement check failed flag",
  },
  entitlementCheckFailedFlagDescription: {
    id: "rovo-extension.hook.entitlement-check-failed-flag-description",
    defaultMessage: "Something went wrong when checking your access to Rovo. Click 'Try again' to access AI chat.",
    description: "Description for the entitlement check failed flag",
  },
  entitlementCheckFailedFlagAction: {
    id: "rovo-extension.hook.entitlement-check-failed-flag-action",
    defaultMessage: "Try again",
    description: "Action for the entitlement check failed flag",
  },
});
